import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useCallback,
} from "react";
// import {  useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { actlistData, actmore, setisfirsttime } from "../../actions/index";
import Navigationtitle from "../include/Navigationtitle";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import DataService from ".././../services/tutorial.service";
import ExternalDataService from ".././../services/external.service";
import {
  getDatabase,
  ref,
  remove,
  push,
  onValue,
  set,
  off,
  update,
} from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faL, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { confirmAlert } from "react-confirm-alert";
import { gif1, gif2, gif3, gif4 } from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

export default function AuctionCustomization(match) {
  const dispatch = useDispatch();

  const loginuser = useSelector((state) => state.setUserlog);

  const aucmoredetail = useSelector((state) => state.actmoredata);
  const [aucdetail, setaucdetail] = useState(aucmoredetail);
  const [aucback, setaucback] = useState("");
  const [selectedOption, setSelectedOption] = useState("0");

  const [aucbackbox, setaucbackbox] = useState("");
  const [aucstampbox, setaucstampbox] = useState("");
  const [aucustampbox, setaucustampbox] = useState("");
  const [aucsoldstamp, setaucsoldstamp] = useState("");
  const [aucunsoldstamp, setaucunsoldstamp] = useState("");
  const [aucsponsorbox, setaucsponsorbox] = useState("");
  const [aucbannerbox, setaucbannerbox] = useState("");
  const [aucsponsor, setaucsponsor] = useState("");
  const [aucbanner, setaucbanner] = useState("");
  const [aucaudio, setaucaudio] = useState("");
  const [isimgpop, setisimgpop] = useState(false);
  const [imgpopdata, setimgpopdata] = useState([]);
  const [imgpoptype, setimgpoptype] = useState("");
  const [isbgpop, setisbgpop] = useState(false);
  const [bgdata, setbgdata] = useState([]);
  const [isfullbg, setisfullbg] = useState(false);
  const [selectedbgfl, setselectedbgfl] = useState("");
  const [bgfulldata, setbgfulldata] = useState("");
  const [audioFile, setAudioFile] = useState(null);
  const [audioduration, setaudioduration] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isbnUploading, setIsbnUploading] = useState(false);
  const [isUploadingStamp, setIsUploadingStamp] = useState(false);
  const [isunUploadingStamp, setIsunUploadingStamp] = useState(false);


  const [isActive, setActive] = useState(false);
  const [cid, setCid] = useState(loginuser["cid"]);
  const aid = localStorage.getItem("auction_id");
  const updtoken = useSelector((state) => state.updtoken);

  const history = useHistory({ forceRefresh: true });

  const fileInputRefs = useRef(
    Array.from({ length: 8 }, () => React.createRef())
  );

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const GIFComponent = () => {
    switch (selectedOption) {
      case "0":
        return <img src={gif1} alt="GIF 1" />;
      // case '1':
      //   return <img src={gif2} alt="GIF 2" />;
      case "2":
        return <img src={gif2} alt="GIF 3" />;
      case "3":
        return <img src={gif3} alt="GIF 4" />;
      case "4":
        return <img src={gif4} alt="GIF 4" />;
      default:
        return null;
    }
  };
  useEffect(() => {
    //  console.log('auc more detail')
    //  console.log(aucdetail)
    //  console.log(aucmoredetail)
    if (aucmoredetail.more && aucmoredetail.more.length > 0) {
      console.log(aucmoredetail.more);
      if (aucmoredetail.more[0].bg != "" && aucmoredetail.more[0].bg != null) {
        // //  console.log('auc more data bg image...!!')
        setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg);
      }

      if (
        aucmoredetail.more[0].sstamp != "" &&
        aucmoredetail.more[0].sstamp != null
      ) {
        setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp);
      }
      if (
        aucmoredetail.more[0].fireworks != "" &&
        aucmoredetail.more[0].fireworks != null
      ) {
        setSelectedOption(aucmoredetail.more[0].fireworks);
      }
      if (
        aucmoredetail.more[0].usstamp != "" &&
        aucmoredetail.more[0].usstamp != null
      ) {
        setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp);
      }

      // Debug audio data
      if (
        aucmoredetail.more[0].audio != "" &&
        aucmoredetail.more[0].audio != null
      ) {
        console.log("Audio file found:", aucmoredetail.more[0].audio);
        console.log("Audio path:", aucmoredetail.fpath);
        console.log(
          "Full audio URL:",
          aucmoredetail.fpath.replace("/file/", "/audio/") +
            aucmoredetail.more[0].audio
        );
      }
    }
  }, [aucmoredetail]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const isFirstMount = localStorage.getItem("isFirstMount");
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      //  console.log('setting false')
      localStorage.setItem("isFirstMount", false);
    } else {
      //  console.log('going back....')

      localStorage.removeItem("isFirstMount");
      history.push("/auction-detail");
    }
  }, [history]);

  const handleFileChange = (e, t) => {
    const file = e.target.files[0];

    // Check sponsor limit before allowing file selection
    if (t == "4") {
      if (aucdetail && aucdetail.spn && aucdetail.spn.length >= 10) {
        toast.error("Maximum 10 sponsors allowed!", { theme: "colored" });
        e.target.value = "";
        return;
      }
    }

    // Check banner limit before allowing file selection
    if (t == "5") {
      if (aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5) {
        toast.error("Maximum 5 banners allowed!", { theme: "colored" });
        e.target.value = "";
        return;
      }
    }

    if (t == "1") {
      setaucback(file);
    } else if (t == "2") {
      setaucsoldstamp(file);
    } else if (t == "3") {
      setaucunsoldstamp(file);
    } else if (t == "4") {
      setaucsponsor(file);
    } else if (t == "5") {
      setaucbanner(file);
    } else if (t == "6") {
      setaucaudio(file);
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (t == "1") {
          setaucbackbox(event.target.result);
        } else if (t == "2") {
          setaucstampbox(event.target.result);
        } else if (t == "3") {
          setaucustampbox(event.target.result);
        } else if (t == "4") {
          setaucsponsorbox(event.target.result);
        } else if (t == "5") {
          setaucbannerbox(event.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const removefile = async (imgpoptype) => {
    if (imgpoptype == "3" || imgpoptype == "4" || imgpoptype == "5") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};

      if (imgpoptype == "3") {
        vals.fltyp = "bg";
      } else if (imgpoptype == "4") {
        vals.fltyp = "sstamp";
      } else if (imgpoptype == "5") {
        vals.fltyp = "usstamp";
      }
      await DataService.delfiles(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            setisimgpop(false);
            if (imgpoptype == "3") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], bg: "" }],
              }));
            } else if (imgpoptype == "4") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], sstamp: "" }],
              }));
            } else if (imgpoptype == "5") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], usstamp: "" }],
              }));
            }
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "2") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.spnid;

      await DataService.delspn(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 14,
                upd: 2,
                val: imgpopdata.spnid,
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "1") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.bnrid;

      await DataService.delbnr(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 15,
                upd: 2,
                val: { id: imgpopdata.bnrid },
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
  };

  const removeuploads = async (t) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    if (t == "1") {
      vals.fltyp = "bg";
    } else if (t == "2") {
      vals.fltyp = "sstamp";
    } else if (t == "3") {
      vals.fltyp = "usstamp";
    }
    await DataService.delfiles(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          setisimgpop(false);
          if (t == "1") {
            setaucbackbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], bg: "" }],
            }));
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 13,
                upd: 2,
                val: "",
              },
              tkn: updtoken,
            });
          } else if (t == "2") {
            setaucstampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: "" }],
            }));
          } else if (t == "3") {
            setaucustampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: "" }],
            }));
          }
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const delfile = (t) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeuploads(t),
        },
        {
          label: "No",
          // onClick: () => del(id, 0),
        },
      ],
    });
  };

  function showfullbg(ele) {
    setisfullbg(true);
    setbgfulldata(ele);
  }
  function handleDivClick(fl) {
    setselectedbgfl(fl);
  }
  const setfireworkeffect = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    // vals.fltyp = 'bg';
    vals.fireworks = selectedOption;
    await DataService.setfirework(vals, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('firework response')
        //  console.log(response)
        //  console.log(vals)
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          setaucdetail((detail) => ({
            ...detail,
            more: [{ ...detail.more[0], fireworks: selectedOption }],
          }));

          var auccopy = aucdetail;
          auccopy.more[0].fireworks = selectedOption;
          dispatch(actmore(auccopy));
          // const db = getDatabase();
          // set(ref(db, 'map/info/' + aid), {
          //   "type": "1", "upd": "6", 'id': aid, "detail": {
          //     "typ": 13,
          //     "upd": 1,
          //     "val": { img: response.data.newentry.logo },
          //   }, "tkn": updtoken
          // });
          // setisbgpop(false)
          // setselectedbgfl("")

          toast.success("Effect set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          // setaucbackbox(bgdata.path + selectedbgfl)
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const setbg = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    vals.fltyp = "bg";
    vals.fl = selectedbgfl;
    await DataService.setbg(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "map/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 13,
              upd: 1,
              val: { img: response.data.newentry.logo },
            },
            tkn: updtoken,
          });
          setisbgpop(false);
          setselectedbgfl("");

          toast.success("Background set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucbackbox(bgdata.path + selectedbgfl);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const resizeBannerTo1600x900 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          // Calculate scale to fit within max dimensions while maintaining aspect ratio
          const maxWidth = 1600;
          const maxHeight = 900;
          const scale = Math.min(
            1,
            Math.min(maxWidth / img.width, maxHeight / img.height)
          );

          // Calculate final dimensions
          const finalWidth = Math.round(img.width * scale);
          const finalHeight = Math.round(img.height * scale);

          const canvas = document.createElement("canvas");
          canvas.width = finalWidth;
          canvas.height = finalHeight;
          const ctx = canvas.getContext("2d");

          // Check if the original file is PNG to preserve transparency
          const isPNG =
            file.type === "image/png" ||
            file.name.toLowerCase().endsWith(".png");

          // Only fill with white background for non-PNG images (JPEG, etc.)
          if (!isPNG) {
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, finalWidth, finalHeight);
          }

          // Draw image scaled to final dimensions
          ctx.drawImage(img, 0, 0, finalWidth, finalHeight);

          // Convert canvas to blob with optimization
          // Use PNG format to preserve transparency, JPEG for other formats
          const outputType = isPNG ? "image/png" : "image/jpeg";

          // PNG doesn't use quality parameter, so call toBlob conditionally
          const blobCallback = (blob) => {
            if (blob) {
              // Create a new file with the original name and correct MIME type
              const resizedFile = new File([blob], file.name, {
                type: outputType,
                lastModified: Date.now(),
              });
              // Store actual dimensions for later use
              resizedFile.actualWidth = finalWidth;
              resizedFile.actualHeight = finalHeight;
              resolve(resizedFile);
            } else {
              reject(new Error("Failed to resize banner"));
            }
          };

          if (isPNG) {
            canvas.toBlob(blobCallback, outputType);
          } else {
            canvas.toBlob(blobCallback, outputType, 0.92); // 0.92 quality for good balance between quality and size
          }
        };
        img.onerror = () => reject(new Error("Failed to load banner image"));
        img.src = e.target.result;
      };
      reader.onerror = () => reject(new Error("Failed to read banner file"));
      reader.readAsDataURL(file);
    });
  };
  const banneradd = async () => {
    setIsbnUploading(true);
    // Step 0: Check banner limit
    if (aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5) {
      toast.error("Maximum 5 banners allowed!", { theme: "colored" });
      return;
    }

    const start = performance.now();
    setActive(true);

    try {
      // Step 1: Resize banner to max 1600x900
      const resizedBanner = await resizeBannerTo1600x900(aucbanner);
      const bannerWidth = resizedBanner.actualWidth;
      const bannerHeight = resizedBanner.actualHeight;
      console.log(
        `Original size: ${(aucbanner.size / 1024).toFixed(
          2
        )}KB → Resized (${bannerWidth}x${bannerHeight}): ${(
          resizedBanner.size / 1024
        ).toFixed(2)}KB`
      );

      // Step 2: Get presigned URL
      const formData = new FormData();
      formData.append("filename", resizedBanner.name);
      formData.append("fltyp", "bnrimg");

      const hdr = {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };

      const geturlresponse = await ExternalDataService.getSignedUrl(
        formData,
        hdr
      );
      if (!geturlresponse.data.success) {
        throw new Error("Failed to get presigned URL");
      }

      const { presignedUrl, filename } = geturlresponse.data.data;

      // Step 3: Upload to S3
      const uploadresponse = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": resizedBanner.type,
          "x-amz-acl": "public-read",
        },
        body: resizedBanner,
      });

      if (!uploadresponse.ok) {
        const errorText = await uploadresponse.text();
        throw new Error("S3 upload failed: " + errorText);
      }

      const uploadTime = performance.now();
      console.log(
        `S3 upload completed in ${((uploadTime - start) / 1000).toFixed(2)}s`
      );

      // Step 4: Optimistic UI Update
      const tempEntry = {
        img: filename,
        bnrid: null,
        w: bannerWidth,
        h: bannerHeight,
      };
      setaucdetail((prev) => ({
        ...prev,
        bnr: [...prev.bnr, tempEntry],
      }));

      // Reset file inputs & state
      setaucbanner("");
      setaucbannerbox("");
      fileInputRefs.current.forEach((ref) => {
        if (ref.current) ref.current.value = "";
      });

      toast.success("Banner uploaded successfully!", { theme: "colored" });
      setActive(false);

      // Step 5: Save to DB + Firebase in background (non-blocking)
      const formData2 = new FormData();
      formData2.append("img", filename);
      formData2.append("w", bannerWidth);
      formData2.append("h", bannerHeight);
      formData2.append("aid", aid);
      // Add any extra fields here if needed
      // formData2.append("extraField", value);

      DataService.addbanner(formData2, hdr)
        .then(async (res) => {
          const response = res.data;

          if (response.success) {
            // Update Firebase
            const db = getDatabase();
            await set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 15,
                upd: 1,
                val: response.data.newentry,
              },
              tkn: updtoken,
            });

            // Replace temp entry with real DB entry
            setaucdetail((prev) => ({
              ...prev,
              bnr: prev.bnr.map((item) =>
                item.img === filename && item.bnrid === null
                  ? response.data.newentry
                  : item
              ),
            }));

            const dbTime = performance.now();
            console.log(
              `DB + Firebase save completed in ${(
                (dbTime - uploadTime) /
                1000
              ).toFixed(2)}s`
            );
            console.log(`Total time: ${((dbTime - start) / 1000).toFixed(2)}s`);
          } else {
            // Rollback: Remove temp entry
            setaucdetail((prev) => ({
              ...prev,
              bnr: prev.bnr.filter(
                (item) => !(item.img === filename && item.bnrid === null)
              ),
            }));
            toast.error(response.msg || "Failed to save banner metadata");
          }
        })
        .catch((error) => {
          console.error("DB save error:", error);
          // Rollback
          setaucdetail((prev) => ({
            ...prev,
            bnr: prev.bnr.filter(
              (item) => !(item.img === filename && item.bnrid === null)
            ),
          }));
          toast.error("Error saving banner metadata");
        });
    } catch (error) {
      console.error("Error uploading banner:", error);
      toast.error(error.message || "Upload failed");
      setActive(false);
    } finally {
      setIsbnUploading(false);
    }
  };
  const resizeSponsorLogoTo500x500 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          // Calculate scale to fit within max dimensions while maintaining aspect ratio
          const maxWidth = 500;
          const maxHeight = 500;
          const scale = Math.min(
            1,
            Math.min(maxWidth / img.width, maxHeight / img.height)
          );

          // Calculate final dimensions
          const finalWidth = Math.round(img.width * scale);
          const finalHeight = Math.round(img.height * scale);

          const canvas = document.createElement("canvas");
          canvas.width = finalWidth;
          canvas.height = finalHeight;
          const ctx = canvas.getContext("2d");

          // Check if the original file is PNG to preserve transparency
          const isPNG =
            file.type === "image/png" ||
            file.name.toLowerCase().endsWith(".png");

          // Only fill with white background for non-PNG images (JPEG, etc.)
          if (!isPNG) {
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, finalWidth, finalHeight);
          }

          // Draw image scaled to final dimensions
          ctx.drawImage(img, 0, 0, finalWidth, finalHeight);

          // Convert canvas to blob with optimization
          // Use PNG format to preserve transparency, JPEG for other formats
          const outputType = isPNG ? "image/png" : "image/jpeg";

          // PNG doesn't use quality parameter, so call toBlob conditionally
          const blobCallback = (blob) => {
            if (blob) {
              // Create a new file with the original name and correct MIME type
              const resizedFile = new File([blob], file.name, {
                type: outputType,
                lastModified: Date.now(),
              });
              // Store actual dimensions for later use
              resizedFile.actualWidth = finalWidth;
              resizedFile.actualHeight = finalHeight;
              resolve(resizedFile);
            } else {
              reject(new Error("Failed to resize image"));
            }
          };

          if (isPNG) {
            canvas.toBlob(blobCallback, outputType);
          } else {
            canvas.toBlob(blobCallback, outputType, 0.92); // 0.92 quality for good balance between quality and size
          }
        };
        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = e.target.result;
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(file);
    });
  };
  const sponsoradd = async () => {
    setIsUploading(true);
    if (aucdetail && aucdetail.spn && aucdetail.spn.length >= 10) {
      toast.error("Maximum 10 sponsors allowed!", { theme: "colored" });
      return;
    }

    const start = performance.now();
    setActive(true);

    try {
      const resizedLogo = await resizeSponsorLogoTo500x500(aucsponsor);
      const formData = new FormData();
      formData.append("filename", resizedLogo.name);
      formData.append("fltyp", "splogo");

      const hdr = {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: JSON.stringify([
            { cid, aid, token: loginuser["token"] },
          ]),
        },
      };

      const geturlresponse = await ExternalDataService.getSignedUrl(
        formData,
        hdr
      );
      if (!geturlresponse.data.success) {
        throw new Error("Failed to get presigned URL");
      }

      const { presignedUrl, filename } = geturlresponse.data.data;

      const uploadresponse = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": resizedLogo.type,
          "x-amz-acl": "public-read",
        },
        body: resizedLogo,
      });

      if (!uploadresponse.ok) {
        const err = await uploadresponse.text();
        throw new Error("S3 upload failed: " + err);
      }

      const uploadTime = performance.now();
      console.log(
        `S3 upload completed in ${((uploadTime - start) / 1000).toFixed(2)}s`
      );

      const tempEntry = { logo: filename, spnid: null };
      setaucdetail((prev) => ({
        ...prev,
        spn: [...prev.spn, tempEntry],
      }));

      setaucsponsor("");
      setaucsponsorbox("");
      fileInputRefs.current.forEach((ref) => {
        if (ref.current) ref.current.value = "";
      });

      toast.success("Logo uploaded successfully!", { theme: "colored" });
      setActive(false);

      const formData2 = new FormData();
      formData2.append("img", filename);
      formData2.append("aid", aid);
      // add any extra fields here if needed
      // formData2.append("extra", value);

      DataService.addsponsor(formData2, hdr)
        .then(async (res) => {
          const response = res.data;

          if (response.success) {
            // ----- Firebase update -----
            const db = getDatabase();
            await set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 14,
                upd: 1,
                val: response.data.newentry,
              },
              tkn: updtoken,
            });

            setaucdetail((prev) => ({
              ...prev,
              spn: prev.spn.map((item) =>
                item.logo === filename && item.spnid === null
                  ? response.data.newentry
                  : item
              ),
            }));

            const dbTime = performance.now();
            console.log(
              `DB + Firebase completed in ${(
                (dbTime - uploadTime) /
                1000
              ).toFixed(2)}s`
            );
            console.log(`Total time: ${((dbTime - start) / 1000).toFixed(2)}s`);
          } else {
            setaucdetail((prev) => ({
              ...prev,
              spn: prev.spn.filter(
                (item) => !(item.logo === filename && item.spnid === null)
              ),
            }));
            toast.error(response.msg || "Failed to save sponsor metadata");
          }
        })
        .catch((error) => {
          console.error("DB save error:", error);
          // Rollback
          setaucdetail((prev) => ({
            ...prev,
            spn: prev.spn.filter(
              (item) => !(item.logo === filename && item.spnid === null)
            ),
          }));
          toast.error("Error saving sponsor metadata");
        });
    } catch (error) {
      console.error("Sponsor upload error:", error);
      toast.error(error.message || "Upload failed");
      setActive(false);
    } finally {
      setIsUploading(false);
    }
  };
  const chooseback = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.bglist({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          setbgdata(response.data);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
    setisbgpop(!isbgpop);
  };
  const uploadfiles = async (typ) => {
    if (isUploading) return;
    setIsUploading(true);

    if (typ === "sstamp") setIsUploadingStamp(true);
    if (typ === "usstamp") setIsunUploadingStamp(true);
    // -------------------------------------------------
    // 0. Mapping: type → file, max size, resize fn, DB key
    // -------------------------------------------------
    const config = {
      bg: {
        file: aucback,
        maxMB: 5,
        resize: resizeBannerTo1600x900,
        dbKey: "bg",
        fileInputIdx: 2, // adjust if your ref index differs
      },
      sstamp: {
        file: aucsoldstamp,
        maxMB: 1.25,
        resize: resizeSponsorLogoTo500x500,
        dbKey: "sstamp",
        fileInputIdx: 5,
      },
      usstamp: {
        file: aucunsoldstamp,
        maxMB: 1.25,
        resize: resizeBannerTo1600x900,
        dbKey: "usstamp",
        fileInputIdx: 9,
      },
    };

    const cfg = config[typ];
    if (!cfg || !cfg.file) {
      toast.error("No file selected", { theme: "colored" });
      return;
    }

    // -------------------------------------------------
    // 1. File-size guard
    // -------------------------------------------------
    const fileSizeMB = (cfg.file.size / 1024 / 1024).toFixed(2);
    if (Number(fileSizeMB) > cfg.maxMB) {
      toast.error(`File size must be less than ${cfg.maxMB} MB`, {
        theme: "colored",
      });
      return;
    }

    const start = performance.now();
    setActive(true);

    try {
      // -------------------------------------------------
      // 2. Resize
      // -------------------------------------------------
      const resized = await cfg.resize(cfg.file);
      console.log(
        `${typ} – Original: ${(cfg.file.size / 1024).toFixed(2)}KB → ` +
          `Resized (${resized.actualWidth}×${resized.actualHeight}): ${(
            resized.size / 1024
          ).toFixed(2)}KB`
      );

      // -------------------------------------------------
      // 3. Get presigned URL
      // -------------------------------------------------
      const urlForm = new FormData();
      urlForm.append("filename", resized.name);
      urlForm.append("fltyp", typ);

      const hdr = {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: JSON.stringify([
            { cid, aid, token: loginuser["token"] },
          ]),
        },
      };

      const getUrlRes = await ExternalDataService.getSignedUrl(urlForm, hdr);
      if (!getUrlRes.data.success)
        throw new Error("Failed to get presigned URL");

      const { presignedUrl, filename } = getUrlRes.data.data;

      // -------------------------------------------------
      // 4. Upload to S3
      // -------------------------------------------------
      const uploadRes = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": resized.type,
          "x-amz-acl": "public-read",
        },
        body: resized,
      });

      if (!uploadRes.ok) {
        const txt = await uploadRes.text();
        throw new Error("S3 upload failed: " + txt);
      }

      const uploadTime = performance.now();
      console.log(
        `${typ} – S3 upload done in ${((uploadTime - start) / 1000).toFixed(
          2
        )}s`
      );

      // -------------------------------------------------
      // 5. Optimistic UI – show instantly
      // -------------------------------------------------
      const tempEntry = { logo: filename };
      setaucdetail((prev) => ({
        ...prev,
        more: [
          {
            ...prev.more[0],
            [cfg.dbKey]: tempEntry.logo,
          },
        ],
      }));

      // Reset file state & input
      if (typ === "bg") setaucback("");
      if (typ === "sstamp") setaucsoldstamp("");
      if (typ === "usstamp") setaucunsoldstamp("");

      const inputRef = fileInputRefs.current[cfg.fileInputIdx];
      if (inputRef?.current) inputRef.current.value = "";

      toast.success(`${typ.toUpperCase()} uploaded!`, { theme: "colored" });
      setActive(false);

      // -------------------------------------------------
      // 6. DB + Firebase (background – non-blocking)
      // -------------------------------------------------
      const dbForm = new FormData();
      dbForm.append("fltyp", typ);
      dbForm.append("img", filename);

      DataService.addfiles(dbForm, hdr)
        .then(async (res) => {
          const resp = res.data;
          if (!resp.success) throw new Error(resp.msg || "DB save failed");

          // ----- Firebase (same payload you already had) -----
          const db = getDatabase();
          await set(ref(db, "map/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 13,
              upd: 1,
              val: { img: resp.data.newentry.logo },
            },
            tkn: updtoken,
          });

          // ----- Replace temp entry with real DB entry -----
          setaucdetail((prev) => ({
            ...prev,
            more: [
              {
                ...prev.more[0],
                [cfg.dbKey]: resp.data.newentry.logo,
              },
            ],
          }));

          const dbTime = performance.now();
          console.log(
            `${typ} – DB+Firebase done in ${(
              (dbTime - uploadTime) /
              1000
            ).toFixed(2)}s`
          );
          console.log(`Total time: ${((dbTime - start) / 1000).toFixed(2)}s`);
        })
        .catch((err) => {
          console.error("DB save error:", err);
          // ----- Rollback UI -----
          setaucdetail((prev) => ({
            ...prev,
            more: [
              {
                ...prev.more[0],
                [cfg.dbKey]: prev.more[0][cfg.dbKey], // keep old value
              },
            ],
          }));
          toast.error("Failed to save metadata");
        });
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error.message || "Upload failed");
      setActive(false);
    } finally {
      setIsUploadingStamp(false);
      setIsunUploadingStamp(false);
      setIsUploading(false);
    }
  };
  const uploadfilesname = async (typ, name) => {
    console.log("typ");
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();

    if (typ == "audio") {
      formData.append("flname", name);
      formData.append("duration", audioduration);
    }

    formData.append("fltyp", typ);
    await DataService.addfilesname(formData, hdr)
      .then((res) => {
        let response = res.data;
        console.log("Api response is...");
        console.log(response);
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          console.log("Api response is...");
          console.log(response);
          toast.success("Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          // setaucdetail(prev => ({
          //   ...prev,
          //   spn: [...prev.spn, response.data.newentry]
          // }))
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function setimagepopup(item, t) {
    setisimgpop(true);
    setimgpopdata(item);
    setimgpoptype(t);
  }
  const uploadaudio = async () => {
    if (!audioFile) {
      toast.error("Please select an audio file", { theme: "colored" });
      return;
    }

    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    const formData = new FormData();
    formData.append("audioFile", audioFile);
    formData.append("duration", audioduration);
    formData.append("aid", aid);

    try {
      const response = await axios.post(
        "https://superscore.in/api/v1/spa/audio",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        }
      );

      toast.dismiss(toastContainerId);
      console.log("response");
      console.log(response);

      if (response.data.success) {
        console.log("response.data.newentry");
        console.log(response.data);
        uploadfilesname("audio", response.data.data.name);
        document.getElementById("audio").value = "";
        toast.success("Audio uploaded successfully!", {
          theme: "colored",
          position: "bottom-center",
        });
      } else {
        toast.error(response.data.msg || "Upload failed", { theme: "colored" });
      }
    } catch (error) {
      console.error("Audio upload error:", error);
      toast.error("Server error while uploading audio", { theme: "colored" });
    } finally {
      setActive(false);
    }
  };

  const [audioError, setAudioError] = useState("");

  const validateAudioDuration = (file) => {
    return new Promise((resolve) => {
      const audio = new Audio();
      audio.src = URL.createObjectURL(file);

      audio.addEventListener("loadedmetadata", () => {
        const duration = audio.duration;
        URL.revokeObjectURL(audio.src);
        resolve(duration);
      });
    });
  };

  const handleAudioChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const duration = await validateAudioDuration(file);
      console.log("duration");
      console.log(duration);
      if (duration > 11) {
        setAudioError("Audio must be below 10 seconds");
        setAudioFile(null);
        e.target.value = ""; // Reset input
      } else {
        setAudioError("");
        setAudioFile(file);
        setaudioduration(duration);
      }
    }
  };

  return (
    <div>
      <Navigationtitle data={match} />
      {isbgpop && (
        <div id="bgdiv" className="bgdiv">
          <div className="bgpop themeboxmain">
            <div className="headsticky">
              <h3>
                Select Background
                <FontAwesomeIcon
                  onClick={() => {
                    isfullbg ? setisfullbg(false) : setisbgpop(false);
                  }}
                  style={{
                    position: "relative",
                    float: "right",
                    cursor: "pointer",
                  }}
                  icon={faXmark}
                />{" "}
              </h3>
            </div>
            {!isfullbg && (
              <div className="bgpopmain">
                {bgdata.list.map((ele) => {
                  return (
                    <div
                      key={ele.fl}
                      className={`bgimgdiv ${
                        selectedbgfl == ele.fl ? "selbg" : ""
                      }`}
                      onClick={() => handleDivClick(ele.fl)}
                    >
                      <FontAwesomeIcon
                        onClick={() => showfullbg(ele)}
                        className="imgzoom"
                        icon={faExpand}
                      />
                      <img src={bgdata.path + ele.fl} alt="" />
                      {selectedbgfl == ele.fl && (
                        <button onClick={() => setbg()} className="bgsetbtn">
                          set
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {isfullbg && (
              <div className="bgpopmain">
                <img
                  className="bgfullimg"
                  src={bgdata.path + bgfulldata.fl}
                  alt="background"
                />
              </div>
            )}
          </div>
        </div>
      )}
      {isimgpop && (
        <>
          <div className="impopbg"></div>
          <div className="impopmain">
            <div>
              <h3>
                {imgpoptype == "2" && "Sponsor"}
                {imgpoptype == "1" && "Banner"}
                <FontAwesomeIcon
                  onClick={() => setisimgpop(false)}
                  style={{
                    padding: ".5rem",
                    cursor: "pointer",
                    position: "relative",
                    float: "right",
                  }}
                  icon={faXmark}
                />
              </h3>
            </div>
            <div>
              {imgpoptype == "2" && (
                <img src={aucdetail.spath + imgpopdata.logo} alt="" />
              )}
              {imgpoptype == "1" && (
                <img src={aucdetail.bpath + imgpopdata.img} alt="" />
              )}
              {imgpoptype == "3" && (
                <img src={aucdetail.fpath + imgpopdata} alt="" />
              )}
              {imgpoptype == "4" && (
                <img src={aucdetail.fpath + imgpopdata} alt="" />
              )}
              {imgpoptype == "5" && (
                <img src={aucdetail.fpath + imgpopdata} alt="" />
              )}
            </div>
            <div
              onClick={() => removefile(imgpoptype)}
              style={{
                padding: ".5rem",
                cursor: "pointer",
                position: "relative",
                float: "right",
              }}
            >
              {" "}
              <FontAwesomeIcon
                style={{ marginRight: ".5rem" }}
                icon={faTrash}
              />
              Remove
            </div>
          </div>
        </>
      )}

      <div className="auctionHead">
        {aucdetail != "" && aucdetail.detail.auctionname}
      </div>
      {/* <div className='customizationHead'>CUSTOMIZATION</div> */}
      <div className="myflex">
        <div className="auction-details-card-container2 acardcont3 themecustom premium-theme-customize">
          <div className="custom-div premium-theme-content">
            <span className="premium-theme-text">Customize Full Theme</span>
            <span className="premium-theme-badge">NEW</span>
          </div>
          <Link to={"auction-customization2"}>
            <button className="mydesbtn premium-theme-btn">
              <span className="btn-text">Customize</span>
              <span className="btn-icon">✨</span>
            </button>
          </Link>
        </div>
      </div>

      {/* Add the new CSS styles for premium theme customize box */}
      <style jsx>{`
        .premium-theme-customize {
          background: linear-gradient(135deg, #ffffff, #f8f9fa);
          border: none;
          border-radius: 16px;
          padding: 20px 30px;
          box-shadow: 0 10px 30px rgba(41, 128, 185, 0.15);
          position: relative;
          overflow: hidden;
          transition: all 0.4s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .premium-theme-customize:before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            45deg,
            rgba(52, 152, 219, 0.05),
            rgba(41, 128, 185, 0.1)
          );
          z-index: 0;
        }

        .premium-theme-customize:after {
          content: "";
          position: absolute;
          height: 100%;
          width: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          top: 0;
          left: -100%;
          transition: all 0.6s ease;
        }

        .premium-theme-customize:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(41, 128, 185, 0.25);
        }

        .premium-theme-customize:hover:after {
          left: 100%;
        }

        .premium-theme-content {
          display: flex;
          align-items: center;
          gap: 10px;
          position: relative;
          z-index: 1;
        }

        .premium-theme-text {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          letter-spacing: 0.5px;
        }

        .premium-theme-badge {
          background: linear-gradient(135deg, #3498db, #2980b9);
          color: white;
          font-size: 12px;
          font-weight: bold;
          padding: 4px 8px;
          border-radius: 12px;
          letter-spacing: 1px;
          box-shadow: 0 2px 5px rgba(41, 128, 185, 0.3);
        }

        .premium-theme-btn {
          background: linear-gradient(135deg, #3498db, #2980b9) !important;
          border: none !important;
          color: white !important;
          font-weight: 600 !important;
          padding: 10px 24px !important;
          border-radius: 30px !important;
          box-shadow: 0 4px 15px rgba(41, 128, 185, 0.3) !important;
          transition: all 0.3s ease !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          position: relative !important;
          overflow: hidden !important;
          z-index: 1 !important;
        }

        .premium-theme-btn:hover {
          transform: scale(1.05) !important;
          box-shadow: 0 6px 20px rgba(41, 128, 185, 0.4) !important;
        }

        .btn-text {
          position: relative;
          z-index: 2;
        }

        .btn-icon {
          font-size: 16px;
          animation: sparkle 1.5s infinite;
          position: relative;
          z-index: 2;
        }

        @keyframes sparkle {
          0%,
          100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.2);
          }
        }

        /* Simplified Audio Display Styles */
        .audio-display-simple {
          margin-top: 15px;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .audio-label {
          color: #2c3e50;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
        }

        .simple-audio-player {
          width: 100%;
          height: 40px;
          border-radius: 6px;
          background: #ffffff;
          border: 1px solid #e9ecef;
          outline: none;
        }

        .simple-audio-player::-webkit-media-controls-panel {
          background-color: #ffffff;
          border-radius: 6px;
        }

        .simple-audio-player::-webkit-media-controls-play-button {
          background-color: #007bff;
          border-radius: 50%;
        }

        .simple-audio-player::-webkit-media-controls-current-time-display,
        .simple-audio-player::-webkit-media-controls-time-remaining-display {
          color: #495057;
          font-size: 12px;
        }

        .simple-audio-player::-webkit-media-controls-timeline {
          background-color: #e9ecef;
          border-radius: 3px;
          margin: 0 10px;
        }

        .simple-audio-player::-webkit-media-controls-volume-slider {
          background-color: #e9ecef;
          border-radius: 3px;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .audio-display-simple {
            margin-top: 10px;
          }

          .simple-audio-player {
            height: 35px;
          }

          .audio-label {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="myflex">
        <div className="auction-details-card-container2 acardcont3 uploaddiv">
          <div className="striphead">
            <h3>Custom Uploads</h3>
          </div>
          <span className="imglimit">
            Please upload less than 1.25 Mb image
          </span>
          <div className="fileflex">
            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" &&
                  aucdetail.more.length > 0 &&
                  aucdetail.more[0].bg != "" &&
                  aucdetail.more[0].bg != null &&
                  aucback == "" && (
                    <div className="filebtns">
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => {
                            document.getElementById("bg").click();
                          }}
                          style={{ cursor: "pointer" }}
                          icon={faPenToSquare}
                        />
                      </div>
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => delfile("1")}
                          style={{ cursor: "pointer" }}
                          icon={faTrash}
                        />
                      </div>
                    </div>
                  )}
                <div>
                  <label className="updlbl" htmlFor="">
                    Background
                  </label>
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="stripmainbox"
                  onClick={() => {
                    document.getElementById("bg").click();
                  }}
                >
                  {aucbackbox && (
                    <img className="boximg" src={aucbackbox} alt="" />
                  )}

                  <label htmlFor="" style={{ cursor: "pointer" }}>
                    +Add
                  </label>
                  <input
                    className="choosefile"
                    ref={fileInputRefs.current[3]}
                    onChange={(e) => handleFileChange(e, "1")}
                    type="file"
                    id="bg"
                  />
                </div>
                <label
                  onClick={() => chooseback()}
                  className="sugbg"
                  style={{ fontSize: "1.2rem", cursor: "pointer" }}
                  htmlFor=""
                >
                  Suggested Backgrounds
                </label>

                {aucback && (
                  <div class="">
                    <button
                      onClick={() => uploadfiles("bg")}
                      className="updbtnsnew"
                    >
                      Upload
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" &&
                  aucdetail.more.length > 0 &&
                  aucdetail.more[0].sstamp != "" &&
                  aucdetail.more[0].sstamp != null &&
                  aucsoldstamp == "" && (
                    <div className="filebtns">
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => {
                            document.getElementById("sstamp").click();
                          }}
                          style={{ cursor: "pointer" }}
                          icon={faPenToSquare}
                        />
                      </div>
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => delfile("2")}
                          style={{ cursor: "pointer" }}
                          icon={faTrash}
                        />
                      </div>
                    </div>
                  )}
                <div>
                  <label className="updlbl" htmlFor="">
                    Sold Stamp
                  </label>
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="stripmainbox"
                  onClick={() => {
                    document.getElementById("sstamp").click();
                  }}
                >
                  {aucstampbox && (
                    <img className="boximg" src={aucstampbox} alt="" />
                  )}

                  <label htmlFor="" style={{ cursor: "pointer" }}>
                    +Add
                  </label>
                  <input
                    className="choosefile"
                    ref={fileInputRefs.current[4]}
                    onChange={(e) => handleFileChange(e, "2")}
                    type="file"
                    id="sstamp"
                  />
                </div>

                {aucsoldstamp && (
                  <div class="">
                    <button
                      onClick={() => uploadfiles("sstamp")}
                      className="updbtnsnew"
                    >
                      Upload
                    </button>
                    {/* <button
                      onClick={() => uploadfiles("sstamp")}
                      className="updbtnsnew"
                      disabled={isUploadingStamp}
                      style={{
                        width: "100%",
                        opacity: isUploadingStamp ? 0.7 : 1,
                        pointerEvents: isUploadingStamp ? "none" : "auto",
                      }}
                    >
                      {isUploadingStamp ? "Uploading..." : "Upload"}
                    </button> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="fileflex">
            <div className="uploadbox">
              <div className="newstrip">
                {aucdetail != "" &&
                  aucdetail.more.length > 0 &&
                  aucdetail.more[0].usstamp != "" &&
                  aucdetail.more[0].usstamp != null &&
                  aucunsoldstamp == "" && (
                    <div className="filebtns">
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => {
                            document.getElementById("usstamp").click();
                          }}
                          style={{ cursor: "pointer" }}
                          icon={faPenToSquare}
                        />
                      </div>
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          onClick={() => delfile("3")}
                          style={{ cursor: "pointer" }}
                          icon={faTrash}
                        />
                      </div>
                    </div>
                  )}
                <div>
                  <label
                    className="updlbl"
                    style={{ cursor: "pointer" }}
                    htmlFor=""
                  >
                    Unsold Stamp
                  </label>
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="stripmainbox"
                  onClick={() => {
                    document.getElementById("usstamp").click();
                  }}
                >
                  {aucustampbox && (
                    <img className="boximg" src={aucustampbox} alt="" />
                  )}

                  <label htmlFor="">+Add</label>
                  <input
                    className="choosefile"
                    ref={fileInputRefs.current[5]}
                    onChange={(e) => handleFileChange(e, "3")}
                    type="file"
                    id="usstamp"
                  />
                </div>

                {aucunsoldstamp && (
                  <div class="">
                    <button
                      onClick={() => uploadfiles("usstamp")}
                      className="updbtnsnew"
                    >
                      Upload
                    </button>
                    
                  </div>
                )}
              </div>
            </div>
            {/* <div className="uploadbox">
              <div className="newstrip">
                
                <div>
                  <label className="updlbl" style={{ cursor: "pointer" }} htmlFor="">Audio</label>
                </div>
                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('audio').click(); }}>
                  <label htmlFor="">+Add</label>
                  <input className="choosefile" ref={fileInputRefs.current[6]} onChange={(e) => handleFileChange(e, "6")} type="file" id="audio" />

                </div>

                {aucaudio && <div class=""><button onClick={() => uploadfiles('audio')} className="updbtnsnew">Upload</button></div>}

              </div>

            </div> */}
          </div>
        </div>
        <div className="auction-details-card-container2 acardcont3 spnbndiv">
          <div className="striphead">
            <h3>Sponsors and Banners</h3>
            <div
              style={{
                fontSize: "14px",
                color: "#666",
                marginTop: "5px",
                display: "flex",
                gap: "20px",
              }}
            >
              <span>
                Sponsors:{" "}
                <strong
                  style={{
                    color:
                      aucdetail && aucdetail.spn && aucdetail.spn.length >= 8
                        ? "#ff6b6b"
                        : "#4CAF50",
                  }}
                >
                  {aucdetail && aucdetail.spn ? aucdetail.spn.length : 0}/10
                </strong>
              </span>
              <span>
                Banners:{" "}
                <strong
                  style={{
                    color:
                      aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 4
                        ? "#ff6b6b"
                        : "#4CAF50",
                  }}
                >
                  {aucdetail && aucdetail.bnr ? aucdetail.bnr.length : 0}/5
                </strong>
              </span>
            </div>
          </div>
          <div className="bnrsnew">
            <div className="spnbninp">
              <div className="new2strip">
                <div>
                  <label htmlFor="">Sponsor</label>
                  <div
                    className="sponsor-count-info"
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <span
                      className="current-count"
                      style={{
                        color:
                          aucdetail &&
                          aucdetail.spn &&
                          aucdetail.spn.length >= 8
                            ? "#ff6b6b"
                            : "#4CAF50",
                        fontWeight: "bold",
                      }}
                    >
                      {aucdetail && aucdetail.spn ? aucdetail.spn.length : 0}
                    </span>
                    <span className="count-separator">/</span>
                    <span className="max-count" style={{ fontWeight: "bold" }}>
                      10
                    </span>
                    <span className="count-label">sponsors</span>
                  </div>
                </div>
                <div
                  style={{
                    cursor:
                      aucdetail && aucdetail.spn && aucdetail.spn.length >= 10
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      aucdetail && aucdetail.spn && aucdetail.spn.length >= 10
                        ? 0.6
                        : 1,
                  }}
                  className="spnbnbox"
                  onClick={() => {
                    if (
                      !(
                        aucdetail &&
                        aucdetail.spn &&
                        aucdetail.spn.length >= 10
                      )
                    ) {
                      document.getElementById("spn").click();
                    }
                  }}
                >
                  {aucsponsorbox && (
                    <img className="boximg" src={aucsponsorbox} alt="" />
                  )}

                  <label
                    style={{
                      cursor:
                        aucdetail && aucdetail.spn && aucdetail.spn.length >= 10
                          ? "not-allowed"
                          : "pointer",
                      color:
                        aucdetail && aucdetail.spn && aucdetail.spn.length >= 10
                          ? "#999"
                          : "inherit",
                    }}
                    htmlFor=""
                  >
                    +Add
                  </label>

                  <div className="stripmain" style={{ display: "none" }}>
                    <input
                      className="choosefile"
                      ref={fileInputRefs.current[1]}
                      onChange={(e) => handleFileChange(e, "4")}
                      type="file"
                      id="spn"
                    />
                  </div>
                </div>

                {aucsponsor && (
                  <div class="">
                    <button
                      onClick={sponsoradd}
                      className="updbtnsnew"
                      disabled={isUploading}
                      style={{
                        width: "100%",
                        opacity: isUploading ? 0.7 : 1,
                        pointerEvents: isUploading ? "none" : "auto",
                      }}
                    >
                      {isUploading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                )}

                {/* Warning message when approaching limit */}
                {aucdetail &&
                  aucdetail.spn &&
                  aucdetail.spn.length >= 8 &&
                  aucdetail.spn.length < 10 && (
                    <div
                      style={{
                        color: "#ff9800",
                        fontSize: "11px",
                        marginTop: "5px",
                        fontStyle: "italic",
                      }}
                    >
                      Warning: You can add {10 - aucdetail.spn.length} more
                      sponsor(s)
                    </div>
                  )}

                {/* Error message when limit reached */}
                {aucdetail && aucdetail.spn && aucdetail.spn.length >= 10 && (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: "11px",
                      marginTop: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    Maximum sponsor limit reached (10)
                  </div>
                )}
              </div>
            </div>
            <div className="spnbnimg">
              {aucdetail != "" && aucdetail.spn.length > 0 ? (
                aucdetail.spn.map((item) => {
                  return (
                    <>
                      <div>
                        <img
                          onClick={() => setimagepopup(item, "2")}
                          className=""
                          src={aucdetail.spath + item.logo}
                          alt=""
                        />
                      </div>
                    </>
                  );
                })
              ) : (
                <>
                  <div className="spnbnmsg"> Haven't Uploaded Sponsor !!</div>
                </>
              )}
            </div>
          </div>
          <div className="bnrsnew">
            <div className="spnbninp">
              <div className="new2strip">
                <div>
                  <label htmlFor="">Banner</label>
                  <div
                    className="banner-count-info"
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <span
                      className="current-count"
                      style={{
                        color:
                          aucdetail &&
                          aucdetail.bnr &&
                          aucdetail.bnr.length >= 4
                            ? "#ff6b6b"
                            : "#4CAF50",
                        fontWeight: "bold",
                      }}
                    >
                      {aucdetail && aucdetail.bnr ? aucdetail.bnr.length : 0}
                    </span>
                    <span className="count-separator">/</span>
                    <span className="max-count" style={{ fontWeight: "bold" }}>
                      5
                    </span>
                    <span className="count-label">banners</span>
                  </div>
                </div>
                <div
                  style={{
                    cursor:
                      aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5
                        ? 0.6
                        : 1,
                  }}
                  className="spnbnbox"
                  onClick={() => {
                    if (
                      !(aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5)
                    ) {
                      document.getElementById("bnr").click();
                    }
                  }}
                >
                  {aucbannerbox && (
                    <img className="boximg" src={aucbannerbox} alt="" />
                  )}

                  <label
                    style={{
                      cursor:
                        aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5
                          ? "not-allowed"
                          : "pointer",
                      color:
                        aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5
                          ? "#999"
                          : "inherit",
                    }}
                    htmlFor=""
                  >
                    +Add
                  </label>

                  <div className="stripmain" style={{ display: "none" }}>
                    <input
                      className="choosefile"
                      ref={fileInputRefs.current[2]}
                      onChange={(e) => handleFileChange(e, "5")}
                      type="file"
                      id="bnr"
                    />
                  </div>
                </div>
                {aucbanner && (
                  <div class="">
                    {/* <button onClick={() => banneradd()} className="updbtnsnew">
                      Upload
                    </button> */}
                    <button
                      onClick={banneradd}
                      className="updbtnsnew"
                      disabled={isbnUploading}
                      style={{
                        width: "100%",
                        opacity: isbnUploading ? 0.7 : 1,
                        pointerEvents: isbnUploading ? "none" : "auto",
                      }}
                    >
                      {isbnUploading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                )}

                {/* Warning message when approaching limit */}
                {aucdetail &&
                  aucdetail.bnr &&
                  aucdetail.bnr.length >= 4 &&
                  aucdetail.bnr.length < 5 && (
                    <div
                      style={{
                        color: "#ff9800",
                        fontSize: "11px",
                        marginTop: "5px",
                        fontStyle: "italic",
                      }}
                    >
                      You can add {5 - aucdetail.bnr.length} more banner(s)
                    </div>
                  )}

                {/* Error message when limit reached */}
                {aucdetail && aucdetail.bnr && aucdetail.bnr.length >= 5 && (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: "11px",
                      marginTop: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    Maximum banner limit reached (5)
                  </div>
                )}
              </div>
            </div>
            <div className="spnbnimg">
              {aucdetail != "" && aucdetail.bnr.length > 0 ? (
                aucdetail.bnr.map((item) => {
                  return (
                    <>
                      <div>
                        <img
                          onClick={() => setimagepopup(item, "1")}
                          className=""
                          src={aucdetail.bpath + item.img}
                          alt=""
                        />
                      </div>
                    </>
                  );
                })
              ) : (
                <>
                  <div className="spnbnmsg"> Haven't Uploaded Banner !!</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className=" audiosold-section">
        <div className="audio-section">
          <div className="audiotertiary-heading">
            <div className="audioheading">Audio Upload</div>
          </div>

          <div className="audioinput-container">
            <span className="audioinput-heading">
              Audio must be 5 to 10 seconds
            </span>
            <input
              type="file"
              id="audio"
              accept="audio/*"
              onChange={handleAudioChange}
            />
            {audioError && <span className="audio-error">{audioError}</span>}
          </div>
          <div className="uploadbtn-div">
            <button
              onClick={() => uploadaudio()}
              className="mydesbtn uploadbtn"
              disabled={!audioFile || audioError}
            >
              Upload
            </button>
          </div>

          {/* Audio Display Section - Simplified */}
          {aucdetail &&
            aucdetail.more &&
            aucdetail.more.length > 0 &&
            aucdetail.more[0].audio && (
              <div className="audio-display-simple">
                <div className="audio-label">Uploaded Audio:</div>
                <audio
                  controls
                  className="simple-audio-player"
                  preload="metadata"
                  onError={(e) => console.error("Audio loading error:", e)}
                >
                  <source
                    src={`${aucdetail.fpath.replace("/file/", "/audio/")}${
                      aucdetail.more[0].audio
                    }`}
                    type="audio/mp3"
                  />
                  <source
                    src={`${aucdetail.fpath.replace("/file/", "/audio/")}${
                      aucdetail.more[0].audio
                    }`}
                    type="audio/mpeg"
                  />
                  Your browser does not support the audio element.
                </audio>
              </div>
            )}
        </div>

        <div className="sold-section">
          <div className="audiotertiary-heading">
            <div className="audioheading">Sold Effects options</div>
          </div>
          {/* <div className="gifshow2-div"> */}
          <div className="gifdisplay">
            <button
              onClick={() => setSelectedOption("1")}
              className={`gifbuttons ${
                selectedOption == "1" && "gifbuttonelected"
              }`}
            >
              No
            </button>
            <button
              onClick={() => setSelectedOption("2")}
              className={`gifbuttons ${
                selectedOption == "2" && "gifbuttonelected"
              }`}
            >
              1
            </button>
            <button
              onClick={() => setSelectedOption("0")}
              className={`gifbuttons ${
                selectedOption == "0" && "gifbuttonelected"
              }`}
            >
              2
            </button>
            <button
              onClick={() => setSelectedOption("3")}
              className={`gifbuttons ${
                selectedOption == "3" && "gifbuttonelected"
              }`}
            >
              3
            </button>
            <button
              onClick={() => setSelectedOption("4")}
              className={`gifbuttons ${
                selectedOption == "4" && "gifbuttonelected"
              }`}
            >
              4
            </button>
            <button
              className="mydesbtn soldsetbtn"
              onClick={() => setfireworkeffect()}
            >
              Set
            </button>
          </div>

          {/* </div> */}
          <div className="gifcomponent">
            <GIFComponent />
          </div>
        </div>

        {/* <select className='fireworksetbutton' value={selectedOption} onChange={handleOptionChange}>
          <option value="1">No Firework</option>
          <option value="2">Firework 1</option>
          <option value="0">Firework 2</option>
          <option value="3">Firework 3</option>
          <option value="4">Firework 4</option>
        </select> */}
        {/* <button className='mydesbtn fireworksetbutton' onClick={()=>setfireworkeffect()}>Set</button> */}
      </div>
      {/* <div className="auction-details-card-container2 acardcont3 uploaddiv">
        <div className="striphead">
          <h3>Sold Effect</h3>
        </div>
        
      </div> */}
    </div>
  );
}
